import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AbstractDynamicInput } from '../abstract-dynamic-input';

@Component({
    selector: 'odq-dynamic-yes-no',
    templateUrl: './dynamic-yes-no.component.html',
    styleUrls: ['./dynamic-yes-no.component.scss'],
    standalone: false
})
export class DynamicYesNoComponent extends AbstractDynamicInput {

  @Input() hideLabels = false;

  @Output() onChange = new EventEmitter();

  onModelChange() {
    this.onChange.emit();
  }

  constructor(translate: TranslateService) { super(translate) }

}
